// Vue agrandie des œuvres (remplace lightGallery) :
// - ordinateur : image à droite (clic sur l'image = œuvre suivante, la dernière revient à la première ;
//   clavier ; zoom par la loupe ou la molette), à gauche le logo, les infos de l'œuvre puis le menu ;
// - téléphone : image en haut (toucher = suivante, glisser pour défiler, pincer ou loupe pour zoomer),
//   infos dessous, menu repliable.
// Pas de zoom au double clic : il entrerait en conflit avec le clic qui fait avancer.
// Les infos viennent de la liste .c-Gallery__infos rendue par le serveur (champ ACF « informations »).
// Une info absente n'est pas affichée. L'adresse prend #oeuvre-<id> : lien partageable, bouton retour = fermer.

const ZOOM_MAX = 4
const ZOOM_DOUBLE = 2.5
const SWIPE_MIN = 50
const TAP_MAX = 8

const TEXTES = {
    fr: { titre: "Vue agrandie", fermer: "Fermer", zoomer: "Zoomer", dezoomer: "Revenir à la taille normale", menu: "Menu", accueil: "Accueil" },
    en: { titre: "Enlarged view", fermer: "Close", zoomer: "Zoom in", dezoomer: "Back to normal size", menu: "Menu", accueil: "Home" },
}

const T = TEXTES[(document.documentElement.lang || "fr").slice(0, 2)] || TEXTES.fr

const ICONES = {
    fermer: '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    zoom: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m15.5 15.5 5 5M7.5 10.5h6" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M10.5 7.5v6" fill="none" stroke="currentColor" stroke-width="1.5" class="c-Viewer__zoom_plus"/></svg>',
}

let $el, $stage, $frame, $img, $infos, $counter, $zoomBtn, $close, $side, $menuToggle
let items = []
let index = 0
let pushed = false
let lastFocus = null

// Zoom et déplacement
let scale = 1
let tx = 0
let ty = 0
let pointers = new Map()
let gesture = null

let el = (html) => {
    let $t = document.createElement("template")
    $t.innerHTML = html.trim()
    return $t.content.firstChild
}

let build = () => {
    $el = el(`
        <div class="c-Viewer" role="dialog" aria-modal="true" aria-label="${T.titre}" hidden>
            <div class="c-Viewer__stage">
                <div class="c-Viewer__frame"><img class="c-Viewer__img" alt="" draggable="false"></div>
                <div class="c-Viewer__tools">
                    <span class="c-Viewer__counter"></span>
                    <button type="button" class="c-Viewer__tool -zoom" aria-label="${T.zoomer}" aria-pressed="false">${ICONES.zoom}</button>
                    <button type="button" class="c-Viewer__tool -close" aria-label="${T.fermer}">${ICONES.fermer}</button>
                </div>
            </div>
            <aside class="c-Viewer__side">
                <a class="c-Viewer__logo" href="/" aria-label="${T.accueil}"></a>
                <div class="c-Viewer__infos" aria-live="polite"></div>
                <button type="button" class="c-Viewer__menu_toggle" aria-expanded="false">${T.menu}</button>
                <nav class="c-Viewer__menu"></nav>
            </aside>
        </div>`)

    $stage = $el.querySelector(".c-Viewer__stage")
    $frame = $el.querySelector(".c-Viewer__frame")
    $img = $el.querySelector(".c-Viewer__img")
    $infos = $el.querySelector(".c-Viewer__infos")
    $counter = $el.querySelector(".c-Viewer__counter")
    $zoomBtn = $el.querySelector(".-zoom")
    $close = $el.querySelector(".-close")
    $side = $el.querySelector(".c-Viewer__side")
    $menuToggle = $el.querySelector(".c-Viewer__menu_toggle")

    // Logo et menu principal repris de l'en-tête du site
    let $logo = document.querySelector(".t-Header__logo")
    let $logoLink = $el.querySelector(".c-Viewer__logo")

    if ($logo) {
        $logoLink.href = $logo.href
        let $logoImg = $logo.querySelector("img")
        if ($logoImg) $logoLink.appendChild($logoImg.cloneNode())
    }

    let $menu = document.getElementById("menu")

    if ($menu) {
        let $copy = $menu.cloneNode(true)
        $copy.removeAttribute("id")
        let here = location.origin + location.pathname

        for (let $a of $copy.querySelectorAll("a")) {
            if ($a.href.split("#")[0] === here) $a.parentElement.classList.add("-active")
        }

        $el.querySelector(".c-Viewer__menu").appendChild($copy)
    } else {
        $menuToggle.remove()
    }

    $close.addEventListener("click", () => close())
    $zoomBtn.addEventListener("click", () => (scale > 1 ? resetZoom() : zoomAt(ZOOM_DOUBLE, centre())))
    $menuToggle.addEventListener("click", () => {
        let open = !$side.classList.contains("-menu-open")
        $side.classList.toggle("-menu-open", open)
        $menuToggle.setAttribute("aria-expanded", open)
    })

    $img.addEventListener("load", () => $img.classList.remove("-loading"))

    $stage.addEventListener("pointerdown", onPointerDown)
    $stage.addEventListener("pointermove", onPointerMove)
    $stage.addEventListener("pointerup", onPointerUp)
    $stage.addEventListener("pointercancel", onPointerUp)
    $stage.addEventListener("wheel", onWheel, { passive: false })
    document.addEventListener("keydown", (e) => {
        if ($el && !$el.hidden) onKeyDown(e)
    })
    window.addEventListener("popstate", () => {
        if (!$el.hidden && !(history.state && history.state.rzViewer)) close(true)
    })

    document.body.appendChild($el)
}

// ---------- Données des œuvres ----------

let readItem = ($a) => {
    let $item = $a.closest("li") || $a.parentElement
    let $thumb = $a.querySelector("img")
    let infos = []

    for (let $info of $item.querySelectorAll(".c-Gallery__info")) {
        let $label = $info.querySelector(".c-Gallery__info_label")
        let label = $label ? $label.textContent.replace(/\s*:\s*$/, "").trim() : ""
        let value = $info.textContent.slice($label ? $label.textContent.length : 0).trim()
        if (value) infos.push({ label, value })
    }

    return {
        id: $item.dataset.id || "",
        full: $a.getAttribute("href"),
        src: $thumb ? $thumb.getAttribute("src") : $a.getAttribute("href"),
        srcset: $thumb ? $thumb.getAttribute("srcset") || "" : "",
        alt: $thumb ? $thumb.getAttribute("alt") || "" : "",
        infos,
    }
}

let collect = ($gallery) => [...$gallery.querySelectorAll(".-js-gallery-item")].filter(($a) => !$a.closest("[hidden]")).map(readItem)

let escape = (s) => s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]))

let renderInfos = (item) => {
    let html = ""
    let rest = item.infos

    if (rest.length && /^titre|^title/i.test(rest[0].label)) {
        html += `<h2 class="c-Viewer__title">${escape(rest[0].value)}</h2>`
        rest = rest.slice(1)
    }

    if (rest.length) {
        html += '<dl class="c-Viewer__details">'
        for (let info of rest) {
            html += `<div class="c-Viewer__detail"><dt>${escape(info.label)}</dt><dd>${escape(info.value)}</dd></div>`
        }
        html += "</dl>"
    }

    $infos.innerHTML = html
    $side.classList.toggle("-no-infos", !html)
}

// ---------- Ouverture, navigation, fermeture ----------

let open = (list, start, fromHash = false) => {
    if (!list.length) return
    if (!$el) build()

    items = list
    lastFocus = document.activeElement
    $el.hidden = false
    $el.classList.add("-open")
    $el.classList.toggle("-single", items.length < 2)
    document.body.classList.add("-viewer-open")
    pushed = false
    show(start, !fromHash)
    $close.focus({ preventScroll: true })
}

let show = (i, push = false) => {
    index = (i + items.length) % items.length
    let item = items[index]

    resetZoom()
    $img.classList.add("-loading")
    $img.removeAttribute("srcset")
    $img.src = item.src
    if (item.srcset) {
        $img.sizes = window.innerWidth > 1024 ? "75vw" : "100vw"
        $img.srcset = item.srcset
    }
    $img.alt = item.alt || (item.infos[0] ? item.infos[0].value : "")
    $img.dataset.full = item.full
    $img.dataset.fullLoaded = ""
    if ($img.complete && $img.naturalWidth) $img.classList.remove("-loading")

    renderInfos(item)
    $counter.textContent = items.length > 1 ? `${index + 1} / ${items.length}` : ""

    // Précharge les voisines
    for (let d of [1, -1]) {
        let n = items[(index + d + items.length) % items.length]
        if (n && n !== item) {
            let pre = new Image()
            if (n.srcset) {
                pre.sizes = $img.sizes
                pre.srcset = n.srcset
            }
            pre.src = n.src
        }
    }

    if (item.id) {
        let hash = "#oeuvre-" + item.id
        if (push && !pushed) {
            history.pushState({ rzViewer: true }, "", hash)
            pushed = true
        } else if (location.hash !== hash) {
            history.replaceState(history.state, "", hash)
        }
    }
}

let go = (i) => {
    if (items.length > 1) show(i)
}

let close = (fromPopstate = false) => {
    if (!$el || $el.hidden) return

    $el.hidden = true
    $el.classList.remove("-open")
    document.body.classList.remove("-viewer-open")
    resetZoom()

    if (!fromPopstate) {
        if (pushed) {
            history.back()
        } else if (/^#oeuvre-/.test(location.hash)) {
            history.replaceState(null, "", location.pathname + location.search)
        }
    }
    pushed = false

    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true })
}

// ---------- Zoom ----------

let centre = () => {
    let r = $frame.getBoundingClientRect()
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 }
}

let apply = () => {
    let r = $frame.getBoundingClientRect()
    let maxX = (r.width * (scale - 1)) / 2
    let maxY = (r.height * (scale - 1)) / 2
    tx = Math.max(-maxX, Math.min(maxX, tx))
    ty = Math.max(-maxY, Math.min(maxY, ty))
    $img.style.transform = scale > 1 ? `translate(${tx}px, ${ty}px) scale(${scale})` : ""
    $el.classList.toggle("-zoomed", scale > 1)
    $zoomBtn.setAttribute("aria-pressed", scale > 1)
    $zoomBtn.setAttribute("aria-label", scale > 1 ? T.dezoomer : T.zoomer)

    // Pleine définition chargée au premier zoom seulement
    if (scale > 1.2 && !$img.dataset.fullLoaded && $img.dataset.full) {
        $img.dataset.fullLoaded = "1"
        let full = new Image()
        let wanted = $img.dataset.full
        full.onload = () => {
            if ($img.dataset.full !== wanted) return
            $img.removeAttribute("srcset")
            $img.src = wanted
        }
        full.src = wanted
    }
}

// Zoome vers `s` en gardant le point p (coordonnées écran) immobile
let zoomAt = (s, p) => {
    let c = centre()
    let ns = Math.max(1, Math.min(ZOOM_MAX, s))
    let qx = (p.x - c.x - tx) / scale
    let qy = (p.y - c.y - ty) / scale
    tx = p.x - c.x - qx * ns
    ty = p.y - c.y - qy * ns
    scale = ns
    if (scale === 1) tx = ty = 0
    apply()
}

let resetZoom = () => {
    scale = 1
    tx = ty = 0
    if ($img) apply()
}

let onWheel = (e) => {
    e.preventDefault()
    zoomAt(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), { x: e.clientX, y: e.clientY })
}

let onPointerDown = (e) => {
    if (e.target.closest("button")) return
    $stage.setPointerCapture(e.pointerId)
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY })

    if (pointers.size === 2) {
        let [a, b] = [...pointers.values()]
        gesture = { type: "pinch", d0: Math.hypot(a.x - b.x, a.y - b.y) || 1, s0: scale, m0: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, t0: { x: tx, y: ty } }
    } else if (pointers.size === 1) {
        // tap : le geste peut encore devenir un clic « suivante » (pas zoomé, bouton principal)
        gesture = { type: "drag", p0: { x: e.clientX, y: e.clientY }, t0: { x: tx, y: ty }, moved: false, touch: e.pointerType !== "mouse", tap: scale === 1 && e.button === 0 }
    }
}

let onPointerMove = (e) => {
    if (!pointers.has(e.pointerId) || !gesture) return
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY })

    if (gesture.type === "pinch" && pointers.size >= 2) {
        let [a, b] = [...pointers.values()]
        let d = Math.hypot(a.x - b.x, a.y - b.y)
        let m = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }
        let c = centre()
        let ns = Math.max(1, Math.min(ZOOM_MAX, (gesture.s0 * d) / gesture.d0))
        let qx = (gesture.m0.x - c.x - gesture.t0.x) / gesture.s0
        let qy = (gesture.m0.y - c.y - gesture.t0.y) / gesture.s0
        scale = ns
        tx = m.x - c.x - qx * ns
        ty = m.y - c.y - qy * ns
        apply()
    } else if (gesture.type === "drag") {
        let dx = e.clientX - gesture.p0.x
        let dy = e.clientY - gesture.p0.y
        if (Math.hypot(dx, dy) > TAP_MAX) gesture.moved = true
        if (scale > 1) {
            tx = gesture.t0.x + dx
            ty = gesture.t0.y + dy
            apply()
        } else if (gesture.touch) {
            $img.style.transform = `translateX(${dx * 0.6}px)`
        }
    }
}

let onPointerUp = (e) => {
    if (!pointers.has(e.pointerId)) return
    pointers.delete(e.pointerId)

    if (gesture && gesture.type === "drag" && pointers.size === 0) {
        let dx = e.clientX - gesture.p0.x
        let dy = e.clientY - gesture.p0.y

        if (scale === 1) {
            $img.style.transform = ""
            if (gesture.touch && Math.abs(dx) > SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
                go(index + (dx < 0 ? 1 : -1))
            }
        }

        // Clic (ou toucher) sur l'image : œuvre suivante. Jamais si l'image est zoomée,
        // ni après un glisser, un balayage ou un pincement.
        if (gesture.tap && !gesture.moved && scale === 1 && e.type === "pointerup" && onImage(e)) {
            go(index + 1)
        }
    }

    if (pointers.size === 1) {
        // Fin du pincement : le doigt restant déplace l'image
        let [p] = [...pointers.values()]
        gesture = { type: "drag", p0: p, t0: { x: tx, y: ty }, moved: true, touch: true }
    } else if (pointers.size === 0) {
        gesture = null
    }
}

// Le point (x, y) tombe-t-il sur l'image affichée (et non sur le fond autour) ?
let onImage = (e) => {
    let r = $img.getBoundingClientRect()
    let nw = $img.naturalWidth
    let nh = $img.naturalHeight
    let w = r.width
    let h = r.height
    if (nw && nh) {
        // object-fit: contain : surface réellement peinte
        let k = Math.min(r.width / nw, r.height / nh)
        w = nw * k
        h = nh * k
    }
    let x0 = r.left + (r.width - w) / 2
    let y0 = r.top + (r.height - h) / 2
    return e.clientX >= x0 && e.clientX <= x0 + w && e.clientY >= y0 && e.clientY <= y0 + h
}

let onKeyDown = (e) => {
    if (e.key === "Escape") {
        e.preventDefault()
        close()
    } else if (e.key === "ArrowRight") {
        go(index + 1)
    } else if (e.key === "ArrowLeft") {
        go(index - 1)
    } else if (e.key === "+" || e.key === "=") {
        zoomAt(scale * 1.5, centre())
    } else if (e.key === "-") {
        zoomAt(scale / 1.5, centre())
    } else if (e.key === "Tab") {
        // Le focus reste dans la vue agrandie
        let focusables = [...$el.querySelectorAll("a[href], button")].filter(($f) => $f.offsetParent !== null)
        let first = focusables[0]
        let last = focusables[focusables.length - 1]
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault()
            last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault()
            first.focus()
        }
    }
}

// ---------- Branchement sur les galeries ----------

let init = () => {
    let $galleries = document.querySelectorAll(".-js-gallery")

    for (let $gallery of $galleries) {
        $gallery.addEventListener("click", (e) => {
            let $a = e.target.closest(".-js-gallery-item")
            if (!$a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
            e.preventDefault()
            let list = collect($gallery)
            let start = [...$gallery.querySelectorAll(".-js-gallery-item")].filter(($x) => !$x.closest("[hidden]")).indexOf($a)
            open(list, Math.max(0, start))
        })
    }

    // Lien direct vers une œuvre : /rubrique/#oeuvre-123
    let m = location.hash.match(/^#oeuvre-(\d+)$/)
    if (m) {
        let $item = document.getElementById("oeuvre-" + m[1])
        let $gallery = $item && !$item.hidden && $item.closest(".-js-gallery")
        if ($gallery) {
            let $a = $item.querySelector(".-js-gallery-item")
            let start = [...$gallery.querySelectorAll(".-js-gallery-item")].filter(($x) => !$x.closest("[hidden]")).indexOf($a)
            open(collect($gallery), Math.max(0, start), true)
        }
    }
}

export default { init }
